<!-- 员工选择画面 -->
<template>
  <j-modal title="选择" size="normal" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <SelectComponent
      ref="SelectComponent"
      :isModal="true"
      :isMulti="params.isMulti"
      :parent="params.parent"
      :selectionRows="params.selectionRows"
      :excludeDepartId="params.excludeDepartId"
      :excludeRoleId="params.excludeRoleId"
    ></SelectComponent>
  </j-modal>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import SelectComponent from './EmployeeManage'

export default {
  name: 'SelectEmployee',
  components: {
    SelectComponent,
  },
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          // 是否多选
          isMulti: false,
          // 父组件
          parent: '',
          // 选中行
          selectionRows: [],
          // 排除组织ID
          excludeDepartId: '',
          // 排除角色ID
          excludeRoleId: '',
        }
      },
    },
  },
  data() {
    return {
      title: '',
      visible: false,
      loading: false,
      url: {},
    }
  },
  watch: {},
  created() {},
  methods: {
    handleOk() {
      if (this.$refs.SelectComponent.selectionRows.length == 0) {
        this.$message.warning(this.$t('disp.rules.select'))
        return
      }

      this.$refs.SelectComponent.selectionRows.forEach((r) => {
        r.value = r.id
        r.text = r.realname
      })

      this.$emit('emit', this.$refs.SelectComponent.selectionRows)

      this.visible = false
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="less"></style>
